import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Payment, Transaction } from "../../models";
import { QrFormModel, RequestGeneratedQR, ResponseGeneratedQr } from "../../models/qr-form.model";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { PATTERN } from "../../constants/pattern";
import { DOC_TYPES_QR } from "../../core/constants/FormLists";
import { CONSTANTS } from "../../constants/users.constants";
import Swal from "sweetalert2";
import { TokenServiceService } from "../../services/token-service.service";
import { QrService } from "../../services/qr.service";
import { validateUserDevice } from "../../shared/helps/helps";

@Component({
  selector: 'app-qr',
  templateUrl: './qr.component.html',
  styleUrls: ['./qr.component.scss']
})
export class QrComponent implements OnInit {
  @Input() info: Payment;
  @Input() transaction: Transaction;
  @Output() outPutQrEmitter = new EventEmitter();
  form: FormGroup;

  loading: boolean;
  imagenQR: string;
  documentType: string;
  viewResultQR = false;
  listOfDocuments = [];
  isMobileDevice = false;
  enableButtonGenerate = false;
  public qrFormModel: QrFormModel;

  fullNameControl = new FormControl('', [
    Validators.pattern(PATTERN.CHARACTERS_SPACE_CHARACTERS),
    Validators.required,
    Validators.maxLength(50),
  ]);
  documentNumberControl = new FormControl('', [
    Validators.required,
    Validators.pattern(PATTERN.NUMBERS),
    Validators.minLength(6),
    Validators.maxLength(20),
  ]);
  numCelControl = new FormControl('', [
    Validators.required,
    Validators.pattern(PATTERN.NUMBERS),
    Validators.minLength(10),
    Validators.maxLength(20),
  ]);
  emailControl = new FormControl('', [
    Validators.required,
    Validators.email,
    Validators.maxLength(100)
  ]);
  formPrivacyValid: boolean = false;

  constructor(
    private readonly qrService: QrService,
    private readonly tokenService: TokenServiceService,
  ) {
    const docTypesObjectKeys = Object.keys(DOC_TYPES_QR);
    for (let prop of docTypesObjectKeys) {
      this.listOfDocuments.push(DOC_TYPES_QR[prop]);
    }
  }

  ngOnInit() {
    this.loading = false;
    this.qrFormModel = new QrFormModel();
    this.isMobileDevice = this.validMobileDevice();
  }

  /**
   * @description: function that is activated when submitting the form from the button to make the flow of the request to generate a QR
   */
  sendData() {
    this.loading = true;
    this.requestGeneratedQR().then(r => {
    });
  }

  /**
   * @description: Method in charge of collecting the user data to make the request
   */
  async requestGeneratedQR() {
    try {

      const body: RequestGeneratedQR = {
        celphone: this.qrFormModel.cellphone,
        email: this.qrFormModel.email,
        fullname: this.qrFormModel.fullName,
        document_type: this.qrFormModel.documentType,
        document_number: this.qrFormModel.documentNumber
      };

      let token = this.tokenService.getToken();
      this.qrService.getQr(token, body).subscribe({
        next: (response: ResponseGeneratedQr) => {

          switch (response.CODE) {
            case CONSTANTS.CODE_OK:
              this.viewResultQR = true
              this.imagenQR = `data:image/svg+xml;base64,${response.DATA.qrImage}`;
              this.loading = false
              break;
            default:
              this.showAlert(CONSTANTS.ACTION_ERROR, 'error', CONSTANTS.GENERAL_ALERT);
              this.cleanContent();
          }
        }, error: (err) => {
          this.showAlert(CONSTANTS.GENERAL_ALERT, 'error', CONSTANTS.ACTION_ERROR);
          this.cleanContent();
        }
      });

    } catch (error) {
      this.showAlert(CONSTANTS.GENERAL_ALERT, 'error', CONSTANTS.ACTION_ERROR);
      this.cleanContent();
    }
  }

   /**
   *
   * @description {formPrivacyUpdate} Function that obtains the event of the validation of the child component
   * @param valid
  */
   formPrivacyUpdate = (valid: boolean) => {
    this.formPrivacyValid = valid;
  }
  /**
   *
   * @description {completedForms} Function to validate the validations of the parent component and child component
   * @returns
  */
  completedForms = (): boolean => {
    return this.formPrivacyValid &&
    this.fullNameControl.valid &&
    this.documentNumberControl.valid &&
    this.numCelControl.valid &&
    this.emailControl.valid  &&
    this.qrFormModel.documentType.length != 0;
  }

  /**
   * @description: returns the fields that control the flow to their initial state
   */
  cleanContent() {
    this.loading = false;
    this.viewResultQR = false;
    this.imagenQR = "";
  }

  /**
   * @description: PopUp alert service
   */
  showAlert(title, icon, message) {
    Swal.fire({
      title: title,
      text: message,
      icon: icon,
      showCloseButton: true,
      confirmButtonText: CONSTANTS.UNDERSTOOD,
      customClass: {
        popup: 'confirm-popup',
        title: 'confirm-title',
        confirmButton: 'confirm-button',
      }
    })
  }

  /**
   * @description: helper function to return to payment methods
   */
  changeMethod() {
    this.outPutQrEmitter.emit();
  }

  /**
   *
   * @description onResize Validate screen size change
   */
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isMobileDevice = this.validMobileDevice();
  }

  /**
   *
   * @description ValidMobileDevice validate if user has mobile device
   * @returns
   */
  validMobileDevice() {
    return validateUserDevice();
  }
}
